import queryString from "query-string";
import React, { useEffect, useState } from "react";

import { validNumber } from "@utils/calculators";

import {
    CALCULATOR_KEYS,
    trackCalculatorStepStarted,
    trackCalculatorStepSubmitted,
} from "@services/tracking";

import Calculation from "./calculation/calculation.component";
import Result from "./result/result.component";

const CementplateCalculator = () => {
    const q = queryString.parse(location.search);
    const cementplateY = q.cementplateLength ? q.cementplateLength : 0;
    const [cementplateLength, setCementplateLength] = useState(cementplateY);
    const cementplateX = q.cementplateWidth ? q.cementplateWidth : 0;
    const [cementplateWidth, setCementplateWidth] = useState(cementplateX);
    const cementplateZ = q.cementplateThickness ? q.cementplateThickness : 0;
    const [cementplateThickness, setCementplateThickness] =
        useState(cementplateZ);

    const [cementplateArea, setCementplateArea] = useState(0);
    const [cementplateVolume, setCementplateVolume] = useState(0);

    useEffect(() => {
        setCementplateArea(determineCementplateArea());
        setCementplateVolume(determineCementplateVolume());
        trackCalculatorStepStarted(CALCULATOR_KEYS.cementPlate);
    }, []);

    useEffect(() => {
        setCementplateArea(determineCementplateArea());
        setCementplateVolume(determineCementplateVolume());
    }, [cementplateLength, cementplateWidth, cementplateThickness]);

    const determineCementplateArea = () => {
        const length = parseFloat(cementplateLength as string);
        const width = parseFloat(cementplateWidth as string);
        const area = Number(length * width);

        return validNumber(area) ? area : 0;
    };

    const determineCementplateVolume = () => {
        const length = parseFloat(cementplateLength as string);
        const width = parseFloat(cementplateWidth as string);
        const height = parseFloat(cementplateThickness as string) * 0.01; // convert cm to m
        const volume = Number(length * width * height);

        return validNumber(volume) ? volume : 0;
    };

    const setCalculationValue = (field: string, value: any) => {
        // eslint-disable-next-line smells/no-switch
        switch (field) {
            case "cementplateLength": {
                setCementplateLength(value);
                break;
            }
            case "cementplateWidth": {
                setCementplateWidth(value);
                break;
            }
            case "cementplateThickness": {
                setCementplateThickness(value);
                break;
            }
        }
        // @ts-ignore
        trackCalculatorStepSubmitted(CALCULATOR_KEYS.cementPlate);
    };

    const calculationProps = {
        setCalculationValue: setCalculationValue,
        cementplateLength: cementplateLength,
        cementplateWidth: cementplateWidth,
        cementplateThickness: cementplateThickness,
    };
    const resultProps = {
        cementplateArea: cementplateArea,
        cementplateVolume: cementplateVolume,
        mailParams: {
            cementplateLength: cementplateLength,
            cementplateWidth: cementplateWidth,
            cementplateThickness: cementplateThickness,
        },
    };

    return (
        <div id="calculator">
            <Calculation {...calculationProps} />
            <Result {...resultProps} />
        </div>
    );
};

export { CementplateCalculator };
